// extracted by mini-css-extract-plugin
export default {"deletingWrap":"ExtenalImg_deletingWrap__jWFAA","content":"ExtenalImg_content__5kTP6","container":"ExtenalImg_container__JHMQy"};